import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-memberBet",
  "use": "icon-memberBet-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63 63\" id=\"icon-memberBet\"><path d=\"M43.07,44.24H19.91a15.93,15.93,0,0,0-6.16,1.23,16.24,16.24,0,0,0-10,15V63h55.5V60.43A16.24,16.24,0,0,0,52.05,47a16.7,16.7,0,0,0-2.8-1.5,17.63,17.63,0,0,0-3-.92,18.3,18.3,0,0,0-3.16-.31M31.48,0h0A20.5,20.5,0,0,0,12.6,12.61a20.18,20.18,0,0,0-1.53,7.81A20.44,20.44,0,1,0,31.48,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol